import { I18n } from '@/i18n/I18n';
import { Form } from 'react-bootstrap';

export function ContextLogInput(props: {note: string, setNote: (note: string) => void, noteError: string, userEmail: string, setUserEmail: (userEmail: string) => void, userEmailError: string, contextLogLabelText: string}) {
  const {note, setNote, noteError, userEmail, setUserEmail, userEmailError, contextLogLabelText} = props;

  return (
    <>
    <Form.Text className='pb-3'>
      <Form.Label id='reasonForOverride'>{contextLogLabelText}</Form.Label>
      <Form.Control as="textarea" rows={2} style={{ maxHeight: '300px' }} className='overflow-auto' value={note} onChange={(e) => setNote(e.target.value)} aria-labelledby='reasonForOverride' data-testid='reasonForOverride' />
      {noteError && <Form.Text className='text-danger d-block'>{noteError}</Form.Text>}
    </Form.Text>
    <Form.Text className='pb-3'>
      <Form.Label id='userEmail'>{I18n.get('userEmail')}</Form.Label>
      <Form.Control as="textarea" rows={2} style={{ maxHeight: '300px' }} className='overflow-auto' value={userEmail} onChange={(e) => setUserEmail(e.target.value)} aria-labelledby='userEmail' data-testid='userEmail' />
      {userEmailError && <Form.Text className='text-danger'>{userEmailError}</Form.Text>}
    </Form.Text>
  </>
  );
}
